import { Format, ValidationFormat } from '@wix/ambassador-forms-v1-form-template/types';
import { Format as FormatV2, InputType } from '@wix/ambassador-forms-v2-form-template/types';
export function makeValidationOfInputField(inputOptions) {
    return {
        required: inputOptions.required,
        ...makeValidationByType(inputOptions)
    };
}
export function makeValidationByType(inputOptions) {
    switch(inputOptions.inputType){
        case InputType.STRING:
            return {
                string: transformStringType(inputOptions.stringOptions.validation)
            };
        case InputType.NUMBER:
            return {
                number: inputOptions.numberOptions.validation
            };
        case InputType.BOOLEAN:
            return {
                boolean: inputOptions.booleanOptions.validation
            };
        case InputType.ARRAY:
            const arrayType = inputOptions.arrayOptions.validation;
            return {
                array: transformArrayType(arrayType)
            };
        case InputType.OBJECT:
            const objectType = inputOptions.objectOptions.validation;
            return {
                object: transformObjectType(objectType)
            };
        case InputType.PAYMENT:
            return {
                predefined: {
                    format: ValidationFormat.PAYMENT,
                    paymentOptions: inputOptions.paymentOptions.validation
                }
            };
        case InputType.WIX_FILE:
            return {
                predefined: {
                    format: ValidationFormat.WIX_FILE
                }
            };
        case InputType.ADDRESS:
            return {
                predefined: {
                    format: ValidationFormat.MULTILINE_ADDRESS,
                    multilineAddressOptions: inputOptions.addressOptions.validation
                }
            };
        case InputType.MULTILINE_ADDRESS:
            return {
                predefined: {
                    format: ValidationFormat.MULTILINE_ADDRESS,
                    multilineAddressOptions: inputOptions.multilineAddressOptions.validation
                }
            };
        case InputType.SCHEDULING:
            return {
                predefined: {
                    format: ValidationFormat.SCHEDULING
                }
            };
        case InputType.OBJECT_ARRAY:
            return {
                predefined: {
                    format: ValidationFormat.OBJECT_ARRAY,
                    objectArrayOptions: inputOptions.objectArrayOptions.validation
                }
            };
        default:
            throw new Error(`Unknown input type ${inputOptions.inputType}`);
    }
}
function transformArrayType(arrayType) {
    return {
        maxItems: arrayType.maxItems,
        minItems: arrayType.minItems,
        items: transformArrayItems(arrayType.items)
    };
}
function transformPropertiesType(propertiesV2) {
    return {
        string: transformStringType(propertiesV2.stringOptions),
        number: propertiesV2.numberOptions,
        boolean: propertiesV2.booleanOptions,
        ...propertiesV2.arrayOptions && {
            array: transformArrayType(propertiesV2.arrayOptions)
        },
        required: propertiesV2.required
    };
}
function transformArrayItems(items) {
    return {
        string: transformStringType(items.stringOptions),
        number: items.numberOptions,
        boolean: items.booleanOptions,
        object: transformObjectType(items.objectOptions)
    };
}
function transformObjectType(objectType) {
    if (objectType) {
        return {
            properties: Object.entries(objectType.properties).reduce((acc, [key, value])=>{
                acc[key] = transformPropertiesType(value);
                return acc;
            }, {})
        };
    }
    return undefined;
}
function transformStringType(stringTypeV2) {
    return {
        ...stringTypeV2,
        format: transformStringFormat(stringTypeV2?.format)
    };
}
function transformStringFormat(formatV2) {
    switch(formatV2){
        case FormatV2.UNKNOWN_FORMAT:
            return Format.UNDEFINED;
        default:
            return formatV2;
    }
}

//# sourceMappingURL=make-validation-of-input-field.js.map